import { MEASURES } from "./metrics";
import { PLOTS } from "./plots";
import { DWH_QUERIES } from "./dwhQueries";

const MEASURE_MAP = new Map(MEASURES.map(m => [m.id, m]));

/** Desired display order for tag groups. */
const TAG_ORDER = ["Operations", "Bidding Logic", "Advertising Performance"];

const DWH_COLUMNS = DWH_QUERIES.flatMap(q => q.columns);
const DWH_STACKED_CHARTS = DWH_QUERIES.flatMap(q => q.stackedAreaCharts ?? []);

/** Ordered list of unique tags that appear in at least one plot or DWH column. */
export const PLOT_TAGS: string[] = (() => {
  const used = new Set([
    ...PLOTS.flatMap(p => MEASURE_MAP.get(p.measureId)?.tags ?? []),
    ...DWH_COLUMNS.flatMap(c => c.tags ?? []),
    ...DWH_STACKED_CHARTS.flatMap(c => c.tags ?? []),
  ]);
  return TAG_ORDER.filter(t => used.has(t));
})();

/** Sorted list of unique owner names that appear in at least one plot or DWH column. */
export const PLOT_OWNERS: string[] = (() => {
  const used = new Set([
    ...PLOTS.map(p => MEASURE_MAP.get(p.measureId)?.owner).filter((o): o is string => Boolean(o)),
    ...DWH_COLUMNS.map(c => c.owner).filter((o): o is string => Boolean(o)),
    ...DWH_STACKED_CHARTS.map(c => c.owner).filter((o): o is string => Boolean(o)),
  ]);
  return [...used].sort();
})();

/** Returns the tags for a given measure. */
export function getMeasureTags(measureId: string): string[] {
  return MEASURE_MAP.get(measureId)?.tags ?? [];
}

/** Returns the owner for a given measure. */
export function getMeasureOwner(measureId: string): string | undefined {
  return MEASURE_MAP.get(measureId)?.owner;
}
